import { useQuery } from '@tanstack/react-query'
import { listIndeedFlexJobShifts } from 'api/admin/indeedFlex/listIndeedFlexJobShifts'
import { indeedFlexKeys } from './keys'

type UseIndeedFlexJobShiftsQueryRequest = Parameters<
  typeof listIndeedFlexJobShifts
>[0]

export function useIndeedFlexJobShiftsQuery(
  request: UseIndeedFlexJobShiftsQueryRequest | null
) {
  return useQuery({
    queryKey: indeedFlexKeys.jobShiftsList(request ?? undefined),
    queryFn: () => {
      if (request === null) {
        throw new Error('Client and job id are required')
      }
      return listIndeedFlexJobShifts(request)
    },
    enabled: request !== null,
  })
}
